import React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";

import { Locale, LocalisationState } from "../../models";
import { getLocale } from "../../selectors";

export interface InjectedLocaleProps {
    locale: Locale;
}

const mapStateToProps = (state: LocalisationState) => ({
    locale: getLocale(state),
});

export const withLocale = <P extends InjectedLocaleProps>(
    WrappedComponent: ComponentType<P>,
) => {
    const ComponenWithLocale = (props: P) => (
        <WrappedComponent {...props} />
    );
    return connect(mapStateToProps)(ComponenWithLocale);
};
